// Save Social Marketing parameter
function saveSocialUTMParams() {
    const socialMarketingParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let socialMarketingPromoUTMItems = {};

    if (sessionStorage.getItem('socialMarketingPromoUTM')) {
        socialMarketingPromoUTMItems = JSON.parse(sessionStorage.getItem('socialMarketingPromoUTM'));
    }

    socialMarketingParams.forEach((socialMarketingParam) => {
        if (urlParams.has(socialMarketingParam)) {
            const paramValue = urlParams.get(socialMarketingParam);
            socialMarketingPromoUTMItems[socialMarketingParam] = paramValue;
        }
    });
    sessionStorage.setItem("socialMarketingPromoUTM", JSON.stringify(socialMarketingPromoUTMItems));
}
saveSocialUTMParams();
// Save Social Marketing parameter
